@if (value(); as value) {
  <div>
    {{ value.value ?? 0 | glxyCurrency: value.currencyCode }}
  </div>
}
